import {
  Doubts,
  RefundContainer,
  RefundContent,
  Title,
} from '../Refund/styled';

export default function ReturnFAQs() {
  return (
    <RefundContainer>
      <Title>Frequently Asked Questions</Title>
      <Doubts>How can I talk to Mylo customer care?</Doubts>
      <RefundContent>
        You can connect with Mylo customer care on -
        <a className="defaultanchor" href="tel:0804-719-0745">
          {' '}
          +91-8047190745
        </a>{' '}
        . You can also write to us on our email at:{' '}
        <span onClick={() => mailClickHandler('shop@mylofamily.com')}>
          shop@mylofamily.com
        </span>
      </RefundContent>
      <RefundContent>
        Our business hours are from:
        <br /> Chat : 9:00 am - 7:00 pm, Monday - Saturday.
         <br /> Call : 10:00 am - 6:00 pm, Monday - Saturday.
      </RefundContent>
      <Doubts>How can I return products on Mylo?</Doubts>
      <RefundContent>
        You can raise a return request from the Mylo app or website.
        Alternatively, you can also reach out to us via chat/call/mail.
      </RefundContent>
      <Doubts>Will I get a refund if I cancel My Mylo order? </Doubts>
      <RefundContent>
        Yes you will get a full refund if you cancel your Mylo order before it
        is shipped.
      </RefundContent>
      <Doubts>Is the bill required for returning a product on Mylo? </Doubts>
      <RefundContent>
        The original product cover/packaging, label is enough to return the
        product if it complies with the return policy. As a good practice, it is
        better to have the bill handy with you while returning the products,
        which you can also get from the Mylo website.
      </RefundContent>
      <Doubts>Can I cancel my order after it has been shipped?</Doubts>
      <RefundContent>
        Cancellation is not possible once the order is shipped.
      </RefundContent>
    </RefundContainer>
  );
}
